import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { UsersApi } from 'services';
import { HierarchyData, IGetAdminUserDataRequest } from './Dashboard.type';
import {
  getAdminUserDataFailure,
  getAdminUserDataSuccess,
} from './Dashboard.action';
import { GET_ADMIN_USER_DATA_REQUEST } from './Dashboard.constant';

function* workerGetAdminDashboard({ payload }: IGetAdminUserDataRequest) {
  try {
    const data: { data: HierarchyData } = yield call(
      UsersApi.getDashboard,
      payload,
    );

    yield put(getAdminUserDataSuccess(data.data));
  } catch (error) {
    yield put(getAdminUserDataFailure(error));
  }
}

function* watchGetAdminDashboard() {
  yield takeLatest(GET_ADMIN_USER_DATA_REQUEST, workerGetAdminDashboard);
}

export const adminDasboardWatchers = [fork(watchGetAdminDashboard)];
